import { useParams } from "react-router-dom";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import SailingPageInputs from "../../../components/NewsLetter/SailingPageLetterInput";
import Layout from "../../../Layout";

const CreateSailingPageData = () => {
  let params=useParams();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Cruise",
      route: "/shore/cruise-page/genting-dream",
    },
    {
      title: "Add Cruise",
      route: "/shore/cruise-page/genting-dream/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={params?.vessel.replaceAll("-"," ")}>
      <CustomHeaderTitle title={"Create New Cruise"} />
      <HeaderBread
        navigation={navigation}
        title={"Add New Cruise"}
      ></HeaderBread>
      <SailingPageInputs newsletter={{}} />
    </Layout>
  );
};

export default CreateSailingPageData;
